import { apiPost } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/PASSWORD_FORGOTTEN";
export const REQUEST_FORGOTTEN = `${NAMESPACE}/REQUEST`;
export const CHECK_USES_MICROSOFT_SIGN_IN = `${NAMESPACE}/CHECK_USES_MICROSOFT_SIGN_IN`;

export const requestPasswordForgotten = ({ email }) => async (dispatch) => {
  // SSO-only accounts have no password credential to reset - check first so
  // we can point them at the "Sign in with Microsoft" button instead
  const checkAction = apiPost(
    CHECK_USES_MICROSOFT_SIGN_IN,
    "auth/uses-microsoft-sign-in",
    { email },
    { auth: false, preventErrorNotification: true }
  );
  const {
    success: checkSuccess,
    response: usesMicrosoftSignIn,
  } = await dispatch(checkAction);

  if (checkSuccess && usesMicrosoftSignIn === true) {
    return { success: true, response: { usesMicrosoftSignIn: true } };
  }

  return dispatch(
    apiPost(
      REQUEST_FORGOTTEN,
      "auth/reset-tokens",
      { email },
      {
        auth: false,
        preventErrorNotification: true,
      }
    )
  );
};
